import { render, staticRenderFns } from "./technician-detail-table.vue?vue&type=template&id=229c3176&scoped=true&"
import script from "./technician-detail-table.vue?vue&type=script&lang=js&"
export * from "./technician-detail-table.vue?vue&type=script&lang=js&"
import style0 from "./technician-detail-table.vue?vue&type=style&index=0&id=229c3176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c3176",
  null
  
)

export default component.exports